<template>
  <div>
    <div class='setBgImg' :style='`height:${height+50}px`'>
      <div class='showView' :style="`height:${height+30}px;width:${width-30}px`">
        <div class='editPWWarp'>
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" size='medium'>
            <el-form-item label="初始密码" prop="oldPassword">
              <el-input 
                type="text" 
                v-model="ruleForm.oldPassword" 
                onpaste="return false" 
                ondragenter="return false" 
                oncontextmenu="return false" 
                placeholder='初始密码' 
                onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" 
                class="no-autofill-pwd">
              </el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input 
                type="text" 
                v-model="ruleForm.newPassword" 
                placeholder='新密码' 
                onpaste="return false" 
                ondragenter="return false" 
                oncontextmenu="return false"
                onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"  
                class="no-autofill-pwd">
              </el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input 
                type="text" 
                v-model="ruleForm.checkPass" 
                placeholder='确认密码' 
                onpaste="return false" 
                ondragenter="return false" 
                oncontextmenu="return false" 
                onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')" 
                class="no-autofill-pwd">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"  class='commonBtn savePW' plain @click="submitForm('ruleForm')">保存密码</el-button>
              <el-button type="info" class='commonBtn resetPW' plain @click="resetForm('ruleForm')">重置密码</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    let oldValue=(rule,value,callback)=>{
      if(value===''){
        callback(new Error('请输入初始密码'))
      }else{
        callback()
      }
    };
    let newValue=(rule,value,callback)=>{
      if(value===''){
        callback(new Error('请输入密码'))
      }else{
        if(this.ruleForm.checkPass!==''){
          this.$refs.ruleForm.validateField('checkPass')
        }
        callback()
      }
    }
    let checkValue=(rule,value,callback)=>{
      if(value===''){
        callback(new Error('请再次输入密码'));
      }else if(value!==this.ruleForm.newPassword){
        callback(new Error('两次输入密码不一致!'));
      }else{
        callback();
      }
    }
    return{
      ruleForm:{
        oldPassword:'',
        newPassword:'',
        checkPass:''
      },
      rules:{
        oldPassword: [
          { validator: oldValue, trigger: 'blur' }
        ],
        newPassword: [
          { validator: newValue, trigger: 'blur' }
        ],
        checkPass: [
          { validator: checkValue, trigger: 'blur' }
        ]
      }
    };
  },
  methods:{
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params=this.ruleForm;
          axios.put('/system/user/profile/updatePwd',params,{headers:{'Content-Type':'multipart/form-data;charset=utf-8'}}).then(res=>{
            if(res.code==200){
              this.$message({
                type: 'success',
                message: res.msg,
                duration:1000
              });
              this.$refs[formName].resetFields();
            }
          })
        } else {
          return false;
        }
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style>
.editPWWarp{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center
}
.demo-ruleForm{
  width: 500px;
  height: 500px;
}
.editPWWarp .demo-ruleForm .el-input__inner{
  height: 40px;
}
.editPWWarp .no-autofill-pwd .el-input__inner{
  font-family: 'dotsfont';
  ime-mode: disabled;
  font-size:12px
}
.savePW{
  top: 0;
}
.resetPW{
  top: 0;
  left: 135px;
}
</style>
